<template>
    <nav class="relative z-10 flex-wrap items-center justify-between py-4 bg-white shadow-xl md:left-0 md:block md:top-0 md:bottom-0 min-w-min md:w-52" :class="{ close: isClose }">
        <div class="w-full px-0 mx-auto md:min-h-full md:relative">
            <!-- Toggler -->
            <button class="px-3 py-1 text-xl leading-none text-black bg-transparent border border-transparent border-solid rounded opacity-50 cursor-pointer md:hidden" type="button" v-on:click="toggleCollapseShow('bg-white m-2 py-3 px-6')" >
                    <i class="fas fa-bars"></i>
            </button>
            <!-- Brand -->

            <!-- Logo -->
            <div class="flex items-center flex-shrink-0 px-4">
                <inertia-link :href="route('admin')">
                    <img src="/img/osm-logo.svg" alt="OSM" style="max-width: 60%;">
                </inertia-link>
            </div>

            <!-- Collapse -->
            <div class="absolute top-0 left-0 right-0 z-40 items-center flex-1 h-auto rounded shadow md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-4 md:shadow-none" v-bind:class="collapseShow">
                <!-- Collapse header -->
                <div class="block pb-4 mb-4 border-b border-gray-100 border-solid md:min-w-full md:hidden">
                    <div class="flex flex-wrap">
                        <div class="w-6/12">
                            <a class="inline-block p-4 px-6 mr-0 text-sm font-bold text-left text-gray-700 uppercase whitespace-no-wrap md:block md:pb-2 brand-logo" href="javascript:void(0)">
                                Virtual Coach
                            </a>
                        </div>
                        <div class="flex justify-end w-6/12">
                            <button type="button" class="px-3 py-1 text-xl leading-none text-black bg-transparent border border-transparent border-solid rounded opacity-50 cursor-pointer md:hidden" v-on:click="toggleCollapseShow('hidden')">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Navigation -->
                <div class="relative">
                    <ul class="flex flex-col list-none md:flex-col md:min-w-full">
                        <!-- <li class="px-4">
                            <inertia-link class="flex items-center py-3 group" :href="route('admin')">
                                <img src="/img/icons/dashboard.svg" alt="dashboard" class="w-6 h-6">
                                <div class="ml-3" :class="isUrl('') ? 'text-gray-900 focus:outline-none focus:border-indigo-700 transition duration-150 ease-in-out' : 'text-gray-500 hover:text-gray-700  focus:outline-none focus:text-gray-700 transition duration-150 ease-in-out'">
                                    Dashboard
                                </div>
                            </inertia-link>
                        </li> -->
                        <li class="px-4">
                            <inertia-link class="flex items-center py-3 group" :href="route('students')" >
                                <img src="/img/icons/people.svg" alt="users" class="w-6 h-6">
                                <div class="ml-3" :class="isUrl('students') ? 'text-gray-900 focus:outline-none focus:border-indigo-700 transition duration-150 ease-in-out' : 'text-gray-500 hover:text-gray-700  focus:outline-none focus:text-gray-700 transition duration-150 ease-in-out'">
                                    Clienti
                                </div>
                            </inertia-link>
                        </li>
                        <li class="px-4">
                            <inertia-link class="flex items-center py-3 group" :href="route('contacts')">
                                <img src="/img/icons/contact.svg" alt="contacts" class="w-6 h-6">
                                <div class="ml-3" :class="isUrl('contacts') ? 'text-gray-900  focus:outline-none focus:border-indigo-700 transition duration-150 ease-in-out' : 'text-gray-500  hover:text-gray-700  focus:outline-none focus:text-gray-700 transition duration-150 ease-in-out'">
                                    Contatti
                                </div>
                            </inertia-link>
                        </li>
                        <li class="px-4">
                            <inertia-link class="flex items-center py-3 group" :href="route('prizes')">
                                <img src="/img/icons/prize.svg" alt="prizes" class="w-6 h-6">
                                <div class="ml-3" :class="isUrl('prizes') ? 'text-gray-900  focus:outline-none focus:border-indigo-700 transition duration-150 ease-in-out': 'text-gray-500  hover:text-gray-700  focus:outline-none focus:text-gray-700 transition duration-150 ease-in-out'">
                                    Premi
                                </div>
                            </inertia-link>
                        </li>
                        <hr class="my-4 md:min-w-full h-0.5 bg-gray-400" />
                        <li class="px-4">
                            <inertia-link class="flex items-center py-3 group" :href="route('orders')">
                                <img src="/img/icons/shopping-bag.png" alt="audiobooks" class="">
                                <div class="ml-3" :class="isUrl('orders') ? 'text-gray-900  focus:outline-none focus:border-indigo-700 transition duration-150 ease-in-out': 'text-gray-500  hover:text-gray-700  focus:outline-none focus:text-gray-700 transition duration-150 ease-in-out'">
                                    Orders
                                </div>
                            </inertia-link>
                        </li>
                        <li class="px-4">
                            <inertia-link class="flex items-center py-3 group" :href="route('admin_audiobooks')">
                                <img src="/img/icons/open-book.png" alt="audiobooks" class="w-6 h-6">
                                <div class="ml-3" :class="isUrl('admin_audiobooks') ? 'text-gray-900  focus:outline-none focus:border-indigo-700 transition duration-150 ease-in-out': 'text-gray-500  hover:text-gray-700  focus:outline-none focus:text-gray-700 transition duration-150 ease-in-out'">
                                    AudioBooks
                                </div>
                            </inertia-link>
                        </li>
                        <li class="px-4">
                            <inertia-link class="flex items-center py-3 group" :href="route('ebooks')">
                                <img src="/img/icons/open-book.png" alt="ebooks" class="w-6 h-6">
                                <div class="ml-3" :class="isUrl('ebooks') ? 'text-gray-900  focus:outline-none focus:border-indigo-700 transition duration-150 ease-in-out': 'text-gray-500  hover:text-gray-700  focus:outline-none focus:text-gray-700 transition duration-150 ease-in-out'">
                                    E-books
                                </div>
                            </inertia-link>
                        </li>
                        <li class="px-4">
                            <inertia-link class="flex items-center py-3 group" :href="route('books')">
                                <img src="/img/icons/open-book.png" alt="books" class="w-6 h-6">
                                <div class="ml-3" :class="isUrl('books') ? 'text-gray-900  focus:outline-none focus:border-indigo-700 transition duration-150 ease-in-out': 'text-gray-500  hover:text-gray-700  focus:outline-none focus:text-gray-700 transition duration-150 ease-in-out'">
                                    Books
                                </div>
                            </inertia-link>
                        </li>
                        <li class="px-4">
                            <inertia-link class="flex items-center py-3 group" :href="route('consultancies')">
                                <img src="/img/icons/people.svg" alt="consultancy" class="w-6 h-6">
                                <div class="ml-3" :class="isUrl('consultancies') ? 'text-gray-900  focus:outline-none focus:border-indigo-700 transition duration-150 ease-in-out': 'text-gray-500  hover:text-gray-700  focus:outline-none focus:text-gray-700 transition duration-150 ease-in-out'">
                                    Consultancy
                                </div>
                            </inertia-link>
                        </li>
                        <hr class="my-4 md:min-w-full h-0.5 bg-gray-400" />
                        <li class="px-4">
                            <inertia-link class="flex items-center py-3 group" :href="route('slides')">
                                <img src="/img/icons/slide.svg" alt="slides" class="w-6 h-6">
                                <div class="ml-3" :class="isUrl('slides') ? 'text-gray-900  focus:outline-none focus:border-indigo-700 transition duration-150 ease-in-out': 'text-gray-500  hover:text-gray-700  focus:outline-none focus:text-gray-700 transition duration-150 ease-in-out'">
                                    Slide
                                </div>
                            </inertia-link>
                        </li>
                    </ul>                
                    <button v-on:click="closeBar" class="hidden p-4 text-lg text-gray-500 hover:text-gray-600 md:block">
                        <i class="fas fa-arrows-alt-h"></i>
                    </button>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
    import JetApplicationMark from "@/Jetstream/ApplicationMark";
    import Icon from "@/Jetstream/Icon";

    export default {
        components: {
            JetApplicationMark,
            Icon,
        },
        data() {
            return {
                collapseShow: "hidden",
                isClose: false,
            };
        },
        props: {
            url: String,
        },
        methods: {
            toggleCollapseShow: function (classes) {
                this.collapseShow = classes;
            },
            closeBar: function () {
                this.isClose = !this.isClose;
            },
            isUrl(...urls) {
                if (urls[0] === "") {
                    return this.url === "";
                }
                return urls.filter((url) => this.url.startsWith(url)).length;
            },
        },
    };
</script>